var moduleMap = {
	"./Module": function() {
		return Promise.all([__webpack_require__.e(223), __webpack_require__.e(23), __webpack_require__.e(416), __webpack_require__.e(82), __webpack_require__.e(51), __webpack_require__.e(945), __webpack_require__.e(375), __webpack_require__.e(237), __webpack_require__.e(417), __webpack_require__.e(748)]).then(function() { return function() { return (__webpack_require__(8748)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});